<template>
    <div class="image">
        <img class="image--el" :src="content.image.url" :alt="content.image.alt">
        <!-- <pre v-if="content" v-text="content"></pre> -->
    </div>
</template>

<script>
    import cmsPluginMixin from 'framework/mixins/cms/cms-plugin';


    export default {
        mixins: [
            cmsPluginMixin,
        ],
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/cms-plugins/image/index.vue?04f9c64e